import $ from "utils/net";
import Config from "../config";

export class FortuneWheelApi {
    private readonly cacheKey = "fortune.wheel.last-hour";
    constructor(
        private readonly cache: Storage
    ) {}

    public async getFortuneWheelStatus(): Promise<FortuneWheelResponse> {
        const data = await $.promiseGetJSON(Config.softionAPI + "/cms/fortuneWheel");
        const fortuneWheelInfo: FortuneWheelResponse = data.data;
        return fortuneWheelInfo;
    }

    public async claimFortuneWheel(): Promise<PrizeEntry> {
        const data = await $.promiseGetJSON(Config.softionAPI + "/cms/fortuneWheelClaim");
        const userPrize: PrizeEntry = data.data;
        return userPrize;
    }
}

export class FortuneWheelEvents {
    static listeners: (() => void)[] = [];
    static addListner(cb: (() => void)) {
        this.listeners.push(cb);
    }
    static removeListener(cb: (() => void)) {
        this.listeners = this.listeners.filter(c => c != cb);
    }
    static trigger() {
        this.listeners.forEach(cb => cb());
    }
}

export interface FortuneWheelResponse {
    enabled: boolean;
    prizes: PrizeEntry[]
}


export interface PrizeEntry {
    id: number,
    text?: string,
    prize?: {
        amount: string,
        currency: string
    }
}
